<div class="chartjs-graph row m-0"
  [ngStyle]="{'height': configOptions.rowHeight ? configOptions.rowHeight : '100%'}" *ngIf="configOptions">
  <div
    class="chart-column p-2 {{configOptions.columnCount ? configOptions.columnCount : ''}} {{configOptions.border ? configOptions.border : ''}}">


    <div class="chart-canvas" [ngClass]="{'chart-canvas-full': !configOptions.showCalendar}">
      <!-- <div *ngIf="insightData.data.length == 0" class="text-center pt-5">No data - {{insightData.ruleDisplayName}}</div> -->
      <canvas id="{{insightId}}" ></canvas>
    </div>


  </div>
</div>